import { useEffect } from 'react'
import { CoralogixRum } from '@coralogix/browser'

/**
 * We are using Coralogix RUM (Real User Monitoring) to track our core web
 * vitals and other performance metrics.
 *
 * See more: https://coralogix.com/docs/user-guides/rum/getting-started/real-user-monitoring/
 */
export default function InitCoralogixRum(
  appEnv?: string,
  coralogixRumPublicKey?: string,
  buildstamp?: string,
) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      CoralogixRum.init({
        environment: appEnv,
        application: 'whammy',
        version: buildstamp ?? '1.0.0',
        public_key: coralogixRumPublicKey,
        coralogixDomain: 'US2',
        supportMfe: false,
        traceParentInHeader: {
          enabled: true,
        },
        memoryUsageConfig: {
          enabled: true,
          interval: 300_000,
        },
      })
    }
  }, [appEnv, buildstamp, coralogixRumPublicKey])

  return null
}
